import Vue from 'vue';
import Router from 'vue-router';
import routes from './router'
import NProgress from 'nprogress'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.publicPath,
    routes,
});

// vue 中导航重复点击报错冗余导航
const originalPush: any = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

router.afterEach((to, from) => {
    NProgress.done();
    window.scrollTo(0, 0)
})

router.beforeEach(async (to, from, next) => {
    NProgress.start();
    /* 路由发生变化修改页面title */
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    next();
    /* must call `next` */
})

export default router;
